// src/components/studio-upload-meta/studio-upload-meta.css.mjs

import { css } from 'lit';

export default css`
	:host {
		display: block;
		font-family: Arial, sans-serif;
		color: var(--on-surface);
	}

	.studio-upload-meta {
		position: relative;
		width: 768px;
		margin: 0px auto;
		height: 100%;
		display: flex;
		flex-direction: column;
		scroll-behavior: smooth;
		overscroll-behavior: contain;
	}

	.title {
		font-size: 1.2rem;
		max-width: 95%;
		font-weight: bold;
		margin-bottom: 20px;
		text-align: center;
	}

	.top-right {
		position: absolute;
		top: 0;
		right: 0;
	}

	.top-right button {
		background-color: var(--surface-raised);
	}
	.title-tooltip {
		display: flex;
		justify-content: start;
		gap: var(--spacing-sm);
	}
	.loading-bar-container {
		margin-bottom: 20px;
	}

	.fixed-metadata {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
	}

	.thumbnail-container {
		background-color: var(--surface-raised);
		border-radius: 8px;
		flex: 0 0 50%;
		display: flex;
		min-height: 200px;
		max-height: 300px;
		justify-content: center;
		align-items: center;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	.thumbnail-container ::slotted(.thumbnail) {
		object-fit: cover;
		object-position: center top;
		border-radius: 8px;
		width: 100%;
		height: -webkit-fill-available;
		box-sizing: border-box;
	}

	.thumbnail-buttons {
		position: absolute;
		top: 10px;
		left: 10px;
		right: 10px;
		display: flex;
		justify-content: space-between;
		z-index: 1;
	}

	.thumbnail-buttons > studio-button {
		width: 25%;
	}

	.metadata-container {
		flex: 1;
		gap: 8px;
		display: grid;
	}

	.metadata-row {
		display: flex;
		align-items: center;
		gap: 8px;
		background-color: var(--color-gray-1);
		border-radius: 8px;
		padding: 8px;
	}

	.metadata-row .icon {
		flex: 0 0 16px;
	}

	.metadata-row .label {
		min-width: 125px;
		font-weight: bold;
	}

	.metadata-row .value {
		color: var(--on-surface);
	}

	.metadata-label {
		font-weight: bold;
		margin: 20px 0 10px;
	}

	.update-metadata {
		flex-direction: column;
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		width: stretch;
		box-sizing: border-box;
		margin-top: 1rem;
	}

	.input-container {
		flex: 1;
	}

	.input-container .input {
		display: block;
		margin-bottom: 15px;
	}

	.collection-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-stert;
		gap: var(--spacing-md);
	}

	.collection-container ::slotted(*) {

	}

	.collection-container ::slotted(button) {
		display: block;
		width: 100%;
		margin-bottom: 10px;
		background-color: var(--color-app-dam);
		color: white;
		border: none;
		padding: 8px;
		border-radius: 4px;
		cursor: pointer;
	}

	.collection-container ::slotted(button:hover) {
		background-color: var(--color-app-dam);
	}

	.collection-container ::slotted(p) {
		font-size: 0.9rem;
		color: var(--on-surface-muted);
	}

	.collection-container ::slotted(div) {
		display: flex;
		gap: 8px;
	}

	.collection-container ::slotted(span) {
		display: inline-block;
		background-color: var(--surface-sunken);
		padding: 4px 8px;
		border-radius: 12px;
		font-size: 0.85rem;
	}

	.action-buttons-container {
		margin-top: 20px;
		position: sticky;
		bottom: 0;
		right: 0;
		display: block;
		padding: 10px;
		background: var(--surface-raised);
		height: auto;
		box-sizing: border-box;
		width: 100%;
		box-shadow: var(--shadow-300);
	}

	.action-buttons-grid {
		display: grid;
		grid-template-columns: repeat(var(--max-x, 1), minmax(0, 1fr));
		gap: 10px;
	}

	.action-buttons-grid .action-button[x] {
		grid-column: calc(attr(x) + 1);
	}

	@media (max-width: 1024px) {
		.studio-upload-meta {
			width: 100%;
		}
		.thumbnail-container {
			flex: unset;
		}
		.fixed-metadata {
			flex-direction: column;
		}
	}
`;
